import { render, staticRenderFns } from "./feature-nonpromo-items.vue?vue&type=template&id=6b1657b6&scoped=true"
import script from "./feature-nonpromo-items.vue?vue&type=script&lang=js"
export * from "./feature-nonpromo-items.vue?vue&type=script&lang=js"
import style0 from "./feature-nonpromo-items.vue?vue&type=style&index=0&id=6b1657b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1657b6",
  null
  
)

export default component.exports